import { render, staticRenderFns } from "./header.html?vue&type=template&id=0cbfde18&scoped=true&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=0cbfde18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbfde18",
  null
  
)

export default component.exports